import { colors } from 'ui/theme/colors';
import { getColor } from 'ui/icons/utils';
import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';

export const SendWebPush24 = ({
  height = 24,
  width = 24,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 24 24" {...props}>
    <path
      d="M8 19H16V20C16 20.5523 15.5523 21 15 21H9C8.44772 21 8 20.5523 8 20V19Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M22 10.1973C21.1175 10.7078 20.0929 11 19 11C15.6863 11 13 8.31371 13 5C13 4.29873 13.1203 3.62556 13.3414 3H4C2.89543 3 2 3.89543 2 5V15C2 16.1046 2.89543 17 4 17H20C21.1046 17 22 16.1046 22 15V10.1973Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M23 5C23 7.20914 21.2091 9 19 9C16.7909 9 15 7.20914 15 5C15 2.79086 16.7909 1 19 1C21.2091 1 23 2.79086 23 5Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
